<template>
    <p class="no-results">
        <slot />
    </p>
</template>

<style src="./NoResults.less" lang="less">
</style>
